export class Barcode {
	base64: string;
}
